function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

//
import * as React from 'react';
import { color } from "../../styles/theme";
import Button from "./Button";
import { compose, withStateHandlers } from 'recompose';
import Truncate from "./Truncate";
import cx from 'classnames';

function ExpandableLink(_ref) {
  var text = _ref.text,
      hasEllipsis = _ref.hasEllipsis,
      onClick = _ref.onClick,
      btnStyle = _ref.btnStyle;
  var textClassName = 'text-uppercase font-sm bold';
  return React.createElement("span", {
    className: textClassName
  }, hasEllipsis && '...', ' ', React.createElement(Button, {
    style: btnStyle,
    rootClassName: cx(textClassName, 'p-a-0'),
    onClick: onClick,
    type: "link"
  }, text));
}

function renderEllipsisFn(_ref2) {
  var more = _ref2.more,
      less = _ref2.less,
      isExpanded = _ref2.isExpanded,
      toggleExpand = _ref2.toggleExpand,
      btnStyle = _ref2.btnStyle;
  return isExpanded ? React.createElement(ExpandableLink, {
    text: less,
    onClick: toggleExpand,
    btnStyle: btnStyle
  }) : React.createElement(ExpandableLink, {
    hasEllipsis: true,
    text: more,
    onClick: toggleExpand,
    btnStyle: btnStyle
  });
}

function ReadMore(_ref3) {
  var children = _ref3.children,
      isExpanded = _ref3.isExpanded,
      _ref3$less = _ref3.less,
      less = _ref3$less === void 0 ? 'Less' : _ref3$less,
      _ref3$lines = _ref3.lines,
      lines = _ref3$lines === void 0 ? 2 : _ref3$lines,
      _ref3$tag = _ref3.tag,
      tag = _ref3$tag === void 0 ? 'span' : _ref3$tag,
      _ref3$more = _ref3.more,
      more = _ref3$more === void 0 ? 'More' : _ref3$more,
      toggleExpand = _ref3.toggleExpand,
      _ref3$renderEllipsis = _ref3.renderEllipsis,
      renderEllipsis = _ref3$renderEllipsis === void 0 ? renderEllipsisFn : _ref3$renderEllipsis,
      btnStyle = _ref3.btnStyle,
      rest = _objectWithoutProperties(_ref3, ["children", "isExpanded", "less", "lines", "tag", "more", "toggleExpand", "renderEllipsis", "btnStyle"]);

  var combinedBtnStyle = Object.assign({
    color: color.primary,
    verticalAlign: 'baseline',
    minHeight: 28
  }, btnStyle);
  return React.createElement("div", null, React.createElement(Truncate, _extends({
    tag: tag,
    lines: !isExpanded && lines,
    ellipsis: renderEllipsis({
      more: more,
      less: less,
      toggleExpand: toggleExpand,
      isExpanded: false,
      btnStyle: combinedBtnStyle
    })
  }, rest), children), isExpanded && renderEllipsis({
    more: more,
    less: less,
    toggleExpand: toggleExpand,
    isExpanded: true,
    btnStyle: combinedBtnStyle
  }));
}

ReadMore.defaultProps = {
  lines: 2,
  more: 'More',
  less: 'Less',
  tag: 'span'
};
export default compose(withStateHandlers({
  isExpanded: false
}, {
  toggleExpand: function toggleExpand(_ref4) {
    var isExpanded = _ref4.isExpanded;
    return function () {
      return {
        isExpanded: !isExpanded
      };
    };
  }
}))(ReadMore);